import './INF.css';
import React from "react";
import founders from './assets/founders.png'
import closingText from './assets/closingText.png'

function ClosingMessage(props) {
    return (
        <div class="">
            <img className="closingTextImage" src={closingText} alt="curvy text saying we're closing!"/>
            <div className="closingFlex">
                <img className="foundersImage" src={founders} alt="founders tat and cierra in front of the welcome to instant noodle factory sign"/>
                <p className="thankYouText"> Thanks for your support! We closed our doors in March 2025. Working on Instant Noodle Factory for these past 2 years has been an incredible journey filled with so many unexpected twists and turns. We are so happy that we got to share our love of instant noodles with New York City, and everyone who traveled to visit our small shops!</p>
            </div>
        </div>
    )
}

export default ClosingMessage;